module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"submit":"Надіслати"},"en":{"submit":"Submit"}}')
  delete Component.options._Ctor
}
